import React, { useState } from "react";
import FsLightbox from "fslightbox-react";

const getYouTubeVideoId = (source) => {
  try {
    const url = new URL(source);

    if (url.hostname.includes("youtu.be")) {
      return url.pathname.replace("/", "");
    }

    if (url.hostname.includes("youtube.com")) {
      if (url.pathname.startsWith("/watch")) {
        return url.searchParams.get("v");
      }

      if (url.pathname.startsWith("/embed/")) {
        return url.pathname.split("/embed/")[1].split("/")[0];
      }
    }
  } catch (error) {
    return null;
  }

  return null;
};

const getYouTubeEmbedSource = (source) => {
  const videoId = getYouTubeVideoId(source);

  if (!videoId) {
    return source;
  }

  const origin =
    typeof window !== "undefined" && window.location && window.location.origin
      ? window.location.origin
      : "https://www.marcoslima.ca";
  const params = new URLSearchParams({
    enablejsapi: "1",
    origin,
    rel: "0",
    widget_referrer: origin,
  });

  return `https://www.youtube.com/embed/${videoId}?${params.toString()}`;
};

const getLightboxSources = (sources) =>
  sources.map((source, index) => {
    if (typeof source !== "string" || !getYouTubeVideoId(source)) {
      return source;
    }

    return (
      <iframe
        key={`youtube-${index}`}
        title="YouTube video player"
        src={getYouTubeEmbedSource(source)}
        width="960"
        height="540"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    );
  });

function Portfolio({ portfolio }) {
  const { category, title, image, popupLink, link, imgStyle, content } = portfolio;
  const [toggler, setToggler] = useState(false);
  const [togglerContent, setTogglerContent] = useState(false);

  const handleLightbox = (e) => {
    if (!link) {
      e.preventDefault();
      setToggler(!toggler);
    }

    if (e.target.className === "icon-plus" || e.target.className === "more-content-container") {
      setToggler(false);
    }
  };

  const handleLightboxContent = (e) => {
    if (content){
      e.preventDefault();
      setTogglerContent(!togglerContent);
    }
  };

  const handleIcon = () => {
    if (link) {
      return <i className="icon-link"></i>;
    } else if (popupLink) {
      if (popupLink.length > 1) {
        if (popupLink.toString().match(/youtube/g)) {
          return <i className="icon-camrecorder"></i>;
        }
        return <i className="icon-picture"></i>;
      } else if (popupLink.toString().match(/youtube/g)) {
        return <i className="icon-camrecorder"></i>;
      } else {
        return <i className="icon-magnifier-add"></i>;
      }
    }
    return <i className="icon-magnifier-add"></i>;
  };

  return (
    <>
      <a
        href={link ? link : "!#"}
        className="work-image"
        onClick={handleLightbox}
        target={link ? "_blank" : undefined}
        rel={link ? "noopener noreferrer" : undefined}
      >
        <div className="portfolio-item rounded shadow-dark">
          <div className="details">
            <span className="term text-capitalize">{category}</span>
            <h4 className="title">{title}</h4>
            <span className="more-button">{handleIcon()}</span>
            {content && <div className="more-content-container" onClick={handleLightboxContent}><span className="more-button more-content"><i className="icon-plus"></i></span></div>}
          </div>
          <div className="thumb">
            <img src={image} alt={title} style={imgStyle} />
            <div className="mask"></div>
          </div>
        </div>
      </a>
      {popupLink && <FsLightbox toggler={toggler} sources={getLightboxSources(popupLink)} />}
      {content && <FsLightbox toggler={togglerContent} sources={[
					<div>
            <div className="container fslightbox-details">
              <div className="row">
                <div className="col-lg-12 col-md-12 mb-0">
                  <div className="project-details-desc">
                    <div className="project-details-information">
                      <div className="container">
                        <div className="row">
                          <div className="single-info-box col-md-3">
                            <h4>Segment</h4>
                            <p>{content.segment}</p>
                          </div>
                          <div className="single-info-box col-md-3">
                            <h4>Frontend</h4>
                            <p>{content.frontend}</p>
                          </div>
                          <div className="single-info-box col-md-3">
                            <h4>{content.backend ? "Backend" : "Framework"}</h4>
                            <p>{content.backend ? content.backend : content.framework}</p>
                          </div>
                          <div className="single-info-box col-md-3">
                            <h4>Platform</h4>
                            <p>{content.plataform}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 mt-0">
                  <div className="project-details-desc">
                    <h3>Description</h3>
                    <p>{content.description}</p>
                    {content.demoLink && (
                      <p>
                        <a
                          className="colorpink"
                          href={content.demoLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          View demo
                        </a>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
				]} />}
    </>
  );
}

export default Portfolio;
